import { EffectCoverflow, Pagination, Swiper } from 'swiper';

class TimelineSwiper {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }
    this.element = element;

    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: window.innerWidth > 991 ? 80 : 30,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span>`
            + '&nbspof&nbsp'
            + `<span class="${totalClass}"></span>`;
        },
      },
      on: {
        // init: (swiper) => {
        //   swiper.el.querySelectorAll('.panel').forEach((el) => {
        //     if (typeof el.panel !== 'undefined') {
        //       el.panel.getParagraphHeight();
        //     }
        //   });
        // },
      },
    });
  }
}

export default TimelineSwiper;
